import { useState, useEffect } from "react";
import sanityClient from "../../sanityClient";

export default function HomeChoose({ }) {
  const [homeChooseContent, setHomeChooseContent] = useState(null);

  // Fetch data from Sanity
  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "homePageContent"][0].homewhychooseInteria{
          title, heading1, heading2, heading3, heading4
        }`
      )
      .then((data) => {
        if (data) setHomeChooseContent(data);
      })
      .catch(console.error);
  }, []);


  if (!homeChooseContent) return null;

  const chooseBoxes = [
    { id: "expert", icon: "choose-icon-1.png", text: homeChooseContent.heading1 },
    { id: "execute", icon: "choose-icon-2.png", text: homeChooseContent.heading2 },
    { id: "facility", icon: "choose-icon-3.png", text: homeChooseContent.heading3 },
    { id: "stories", icon: "choose-icon-4.png", text: homeChooseContent.heading4 },
  ];

  return (
    <section className="home-choose">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="heading center-heading">{homeChooseContent.title}</h4>
          </div>

          {chooseBoxes.map(({ id, icon, text }) => (
            <div key={id} className="col-lg-3 col-md-6 col-6 wow animate__animated animate__slideInUp">
              <div className="choose-box" >
                <img src={`/assets/home/${icon}`} alt="icon" />
                <a  href={`#${id}`}> <p>{text}</p> </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
